// extracted by mini-css-extract-plugin
export default {"textArea":"TextDescription_textArea__jK4O1"};